import { ReactElement } from 'react';

import { useRouter } from 'next/router';

import { PrismicRichText } from '@prismicio/react';

import { ProductList } from '@components/organisms/ProductList';

import { useProductListQuery } from '@sdk/gqlTypes/generatedHooks';

import { generateKey } from '@utils/core';
import { localeToSaleorQuery } from '@utils/regions';
import { mapEdgesToItems } from '@utils/maps';

import { IProps } from './types';
import * as S from './styles';

export function SliceRelatedProducts({
  slice: { primary, fields },
}: IProps): ReactElement {
  const { locale } = useRouter();

  const productIds = fields.map((node) =>
    generateKey(`${node.productid}`, 'Product')
  );

  const { data } = useProductListQuery({
    variables: {
      filter: {
        ids: productIds || [],
      },
      first: 4,
      ...localeToSaleorQuery(locale),
      sortBy: null,
    },
  });

  if (data) {
    return (
      <S.Wrapper className="slice-item slice-related-products">
        <S.Title>
          <PrismicRichText field={primary.slicetitle} />
        </S.Title>
        <S.List>
          <ProductList innerList products={mapEdgesToItems(data.products)} />
        </S.List>
      </S.Wrapper>
    );
  }

  return null;
}

SliceRelatedProducts.componentName = 'relatedproducts';
